import { render, staticRenderFns } from "./PlayStatus.vue?vue&type=template&id=314a3e9f&scoped=true"
import script from "./PlayStatus.vue?vue&type=script&lang=js"
export * from "./PlayStatus.vue?vue&type=script&lang=js"
import style0 from "./PlayStatus.vue?vue&type=style&index=0&id=314a3e9f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314a3e9f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('314a3e9f')) {
      api.createRecord('314a3e9f', component.options)
    } else {
      api.reload('314a3e9f', component.options)
    }
    module.hot.accept("./PlayStatus.vue?vue&type=template&id=314a3e9f&scoped=true", function () {
      api.rerender('314a3e9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/call/component/PlayStatus.vue"
export default component.exports